import Image from '@base/Image';
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${Spacings.SPACING_1B};
`;

const AvatarContainer = styled.div`
  &:not(:first-of-type) {
    margin-left: -${Spacings.SPACING_2B};
  }
  height: ${Spacings.SPACING_6B};
`;

const peopleInCircle = [
  { avatar: 'practice-session/female-avatar2.svg' },
  { avatar: 'practice-session/male-avatar1.svg' },
  { avatar: 'practice-session/female-avatar1.svg' }
];

const AvatarGroup = () => {
  return (
    <Wrapper>
      {peopleInCircle.map(({ avatar }) => {
        return (
          <AvatarContainer key={avatar}>
            <Image
              key={avatar}
              src={avatar}
              width="24"
              height="24"
              alt="avatar"
            />
          </AvatarContainer>
        );
      })}
    </Wrapper>
  );
};

export default AvatarGroup;
